// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cg-b";
export var colorBlue = "_cg-8";
export var colorDot = "_cg-0";
export var colorDotLarge = "_cg-2";
export var colorDotSmall = "_cg-1";
export var colorGreen = "_cg-7";
export var colorGrey = "_cg-3";
export var colorOrange = "_cg-5";
export var colorPink = "_cg-a";
export var colorPurple = "_cg-9";
export var colorRed = "_cg-4";
export var colorYellow = "_cg-6";